<template>
  <b-form-group
    label="Vergi Dairesi"
    label-for="tax_office"
  >
    <b-form-input
      id="tax_office"
      v-model="dataItem.tax_office"
      placeholder="Vergi Dairesi"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TaxOffice',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
  },
}
</script>
